import { qs, qsa } from '../utils/dom';

export function initContact() {
  if (!qs('.contact')) return;

  var checkboxPro = document.querySelector('#pro');

  checkboxPro.addEventListener('click', function(e){
    e.preventDefault();

    document.querySelector('#brochure').classList.toggle('is-pro');
    qsa('.contact--pro').forEach(el => el.classList.toggle('is-pro-field'));
  });

  qsa('.contact--checkbox-container').forEach((container) => {
    container.addEventListener('click', () => {
      const checkbox = qs('.contact--input-checkbox', container);
      if (checkbox) checkbox.checked = !checkbox.checked;
    });
  });

  qsa('form.contact--form').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();

      const antiSpam = qs('#amispam', form);
      if (antiSpam && antiSpam.value) {
        console.error('Oh no ! I m Spam');
        return;
      }

      const formData = new FormData(form);
      const mailer = '/wp-content/themes/le-glacier-de-savoie/mailer/send-mail.php';

      const submits = qsa('.contact--submit', form);
      const btnLoading = qs('.contact--submit.is-loading', form);
      const btnSent = qs('.contact--submit.is-sent', form);
      const btnDefault = qs('.contact--submit.is-submit', form);

      submits.forEach((b) => b.classList.remove('is-active'));
      if (btnLoading) btnLoading.classList.add('is-active');

      fetch(mailer, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      })
        .then((r) => { if (!r.ok) throw new Error('Network response was not ok'); return r; })
        .catch(console.error)
        .finally(() => {
          submits.forEach((b) => b.classList.remove('is-active'));
          if (btnSent) btnSent.classList.add('is-active');

          setTimeout(() => {
            submits.forEach((b) => b.classList.remove('is-active'));
            if (btnDefault) btnDefault.classList.add('is-active');
            form.reset();
          }, 5000);
        });
    });
  });

  qsa('.contact--submit.is-loading, .contact--submit.is-sent').forEach((el) => {
    el.addEventListener('click', (e) => e.preventDefault());
  });
}